var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageTanentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 41V32C19 29.238 21.238 27 24 27V27C26.762 27 29 29.238 29 32V41H40V23.828C40 22.768 39.578 21.75 38.828 21L25.414 7.586C24.632 6.804 23.366 6.804 22.586 7.586L9.172 21C8.422 21.75 8 22.768 8 23.828V41H19Z",
    stroke: "#00BAB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageTanentIcon);
export default __webpack_public_path__ + "static/media/manage-tanent-icon.049c0e04f7af78667058c6fa796e37c6.svg";
export { ForwardRef as ReactComponent };